import { getBusinessTripFormOptionsFilter } from '@/constants/options/business-trip-form.option';
import { RoleEnum } from '@/types/enums/role.enum';
import type { KeyWithFilter } from '@/utils/filter/filter';

export const filters = (): KeyWithFilter[] => {
    return [
        {
            key: [
                {
                    key: 'code',
                    trans: 'code.businessTripForm',
                    defaultOperator: 'like',
                },
            ],
            type: 'input',
            value: [],
        },

        {
            key: [
                {
                    key: 'createdDate',
                    trans: 'createdDate',
                    defaultOperator: '=',
                },
                {
                    key: 'checkinPlan',
                    trans: 'checkinPlan',
                    defaultOperator: '=',
                },
                {
                    key: 'checkoutPlan',
                    trans: 'checkoutPlan',
                    defaultOperator: '=',
                },
            ],
            type: 'date',
            value: [],
        },

        {
            key: [
                {
                    key: 'customerId',
                    trans: 'Customers',
                    keyService: 'Customers',
                    defaultOperator: '=',
                    excludeRoles: [RoleEnum.CUSTOMER],
                },
                {
                    key: 'technicalId',
                    trans: 'Người phụ trách',
                    keyService: 'Assignees',
                    defaultOperator: '=',
                    excludeRoles: [RoleEnum.KTV],
                },
            ],
            type: 'orm',
            value: [],
        },

        {
            key: [
                {
                    key: 'status',
                    trans: 'status',
                    defaultOperator: '=',
                },
            ],
            type: 'select',
            value: getBusinessTripFormOptionsFilter(true),
        },
    ];
};
